// this idea taken from https://turfjs.org/getting-started

import circle from '@turf/circle'
import booleanContains from '@turf/boolean-contains'
import booleanCrosses from '@turf/boolean-crosses'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import booleanIntersects from '@turf/boolean-intersects'
import polygonToLine from '@turf/polygon-to-line'
import intersect from '@turf/intersect'
import area from '@turf/area'
import rewind from '@turf/rewind'
import difference from '@turf/difference'
import distance from '@turf/distance'
import length from '@turf/length'
import lineSliceAlong from '@turf/line-slice-along'
import centroid from '@turf/centroid'
import centerOfMass from '@turf/center-of-mass'
import bbox from '@turf/bbox'
import bboxPolygon from '@turf/bbox-polygon'
import { convertArea, polygon, multiPolygon, point } from '@turf/helpers'
import lineOffset from '@turf/line-offset'
import transformRotate from '@turf/transform-rotate'
import transformScale from '@turf/transform-scale'
import buffer from '@turf/buffer'
import pointOnFeature from '@turf/point-on-feature'
import simplify from '@turf/simplify'
import combine from '@turf/combine'

export const turf = {
  centerOfMass,
  circle,
  combine,
  convertArea,
  booleanContains,
  booleanCrosses,
  booleanIntersects,
  booleanPointInPolygon,
  polygonToLine,
  intersect,
  area,
  rewind,
  difference,
  distance,
  transformRotate,
  lineSliceAlong,
  length,
  bbox,
  bboxPolygon,
  centroid,
  lineOffset,
  transformScale,
  polygon,
  buffer,
  multiPolygon,
  point,
  pointOnFeature,
  simplify,
}

export default turf
